var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Splash',{attrs:{"id":"loader-splash","message":_vm.message}})}
var staticRenderFns = []

export { render, staticRenderFns }